import { set, toggle } from '@/utils/vuex'

const mutations = {
  setDrawer: set('drawer'),
  setImage: set('image'),
  setColor: set('color'),
  toggleDrawer: toggle('drawer'),
}
const state = {
  drawer: null,
  color: 'success',
  image: 'bg_sidebar.jpg',
}

export default {
  namespaced: true,
  state,
  mutations,
}